import React from 'react';
import { SectionTitle } from '../ui/CommonComponents';
import { SkillCard } from '../ui/SkillCard';
import RevealOnScroll from '../../hooks/useRevealOnScroll';
import { skills } from '../../data/portfolioData';
import { useTranslation } from '../../hooks/useTranslation';

export const SkillsSection = () => {
    const { t } = useTranslation();

    return (
        <section id="skills" className="py-20 px-6 bg-[#111111] border-y border-[#732424]/10">
            <div className="container mx-auto">
                <RevealOnScroll>
                    <SectionTitle title={t('skillsTitle')} subtitle={t('skillsSubtitle')} />
                </RevealOnScroll>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {skills.map((category, index) => (
                        <RevealOnScroll key={index} delay={index * 100}>
                            <SkillCard {...category} />
                        </RevealOnScroll>
                    ))}
                </div>
            </div>
        </section>
    );
};